import environment from "environment";
import EffectUtility from "../../utilities/EffectUtility";
import CustomTicketFieldsModel from "./models/CustomTicketFieldsModel";

//Category effect
export default class CustomTicketFieldEffect {
  // calling an API according to the ProjectModel
  static async requestCustomTicketFields(params) {
    const endpoint = environment.api.custom_ticket_field;

    return EffectUtility.getToModel(CustomTicketFieldsModel, endpoint, params);
  }

  // Custom_ticket_fields filter api
  static async requestCustomTicketFieldsFilter(params) {
    const endpoint = environment.api.custom_ticket_field_filter;

    return EffectUtility.getToModel(CustomTicketFieldsModel, endpoint, params);
  }
}
